import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject = new BehaviorSubject<string | null>(null);

  constructor(private router: Router) { } // Solo Router, no AuthService

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authReq = this.addAuthHeader(request);
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handle401Error(authReq, next);
        }

        if (error.status === 403) {
          console.error('Acceso denegado:', error);
          this.handle403Error();
        }

        return throwError(() => error);
      })
    );
  }

  private addAuthHeader(request: HttpRequest<any>): HttpRequest<any> {
    if (this.requiresAuth(request.url)) {
      const token = this.getToken();
      if (token) {
        return request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            // 'Content-Type': 'application/json'
          }
        });
      }
    }

    return request;
  }

  private requiresAuth(url: string): boolean {
    const publicEndpoints = [
      '/auth/login',
      '/auth/register',
      '/auth/refresh',
      '/auth/verify',
      '/public/',
      '/surveys/responses'
    ];

    return !publicEndpoints.some(endpoint => url.includes(endpoint));
  }

  private getToken(): string | null {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('authToken');
    }
    return null;
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const refreshToken = this.getRefreshToken();
      if (refreshToken) {
        this.cerrarSesion();
        return throwError(() => new Error('Sesión expirada'));
      } else {
        this.isRefreshing = false;
        this.cerrarSesion();
        return throwError(() => new Error('Sesión expirada'));
      }
    }

    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap(token => next.handle(this.addAuthHeader(request)))
    );
  }

  private handle403Error(): void {
    console.warn('Usuario no tiene permisos para acceder a este recurso');
    // this.router.navigate(['/access-denied']);
  }

  private cerrarSesion(): void {
    // Limpiar localStorage sin depender de AuthService
    localStorage.removeItem('authToken');
    localStorage.removeItem('ciafvirtual_refresh_token');
    localStorage.removeItem('user_data');

    // Redirigir al login
    this.router.navigate(['/auth/login']);
  }

  private getRefreshToken(): string | null {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('ciafvirtual_refresh_token');
    }
    return null;
  }
}
